import { AlertVariant } from './Alert';
import { Theme, css } from '@emotion/react';

const getVariant = (colors: Theme['colors'], variant: AlertVariant) => {
  switch (variant) {
    case 'default':
      return css`
        --alert-color: ${colors.textPrimary};
      `;
    case 'negative':
      return css`
        --alert-color: ${colors.textDanger};
      `;
    case 'positive':
      return css`
        --alert-color: ${colors.textSuccess};
      `;
    case 'warning':
      return css`
        --alert-color: ${colors.textWarning};
      `;
    default:
      return css`
        --alert-color: ${colors.textPrimary};
      `;
  }
};

export const alertBase = ({ colors, spacing }: Theme, variant: AlertVariant) => {
  const alertVariantVars = getVariant(colors, variant);
  return css`
    ${alertVariantVars};

    display: flex;
    padding-bottom: ${spacing(1.5)}px;
    padding-top: ${spacing(1.5)}px;
    & svg,
    & a {
      color: var(--alert-color);
    }
  `;
};

export const alertIcon = ({ spacing }: Theme) => css`
  line-height: 1;
  padding-right: ${spacing(2)}px;
  & svg {
    display: block; /* to fix vertical align issue */
  }
`;
